import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../atoms/Icon';
import Headline from '../../atoms/Headline';
import { SantanderLogo } from '../../atoms/Logos';
import { GfdbLogoOriginal } from '../../atoms/Logos';
import { getPaymentGroupLabel } from '../../../utils';
var AppConfig = require('../../../config.json');
/**
 * A simple PaymentSelector.
 */

class PaymentSelector extends React.Component {
	
    render () {
    	
    	const { label, subline } = getPaymentGroupLabel(this.props.choice);
        return (
          <div className={`paymentselector${this.props.selected?" selected":""}`} onClick={() => this.props.onClick(this.props.choice)}>
            {
            	this.props.choice.type==='sf' &&
            	<SantanderLogo />
            }
            {
            	(this.props.choice.type==='pc' || this.props.choice.type==='sos') &&
            	<GfdbLogoOriginal />
            }
            <Icon filename="selected" />
            
            <div className="inner">

            	<div className="desc">
	            	<Headline typeOf="h3" alignment="center">
	              		{label}
	              	</Headline>
	              	<div className="subline" style={{color:(this.props.selected?"#222":"#999")}}>
	              		{subline}
	              	</div>
                    {
                        this.props.choice.type==='pc' &&
                        <div className="cashdiscount">{AppConfig.payments.cashdiscount}</div>
                    }
            	</div>
            </div>

          </div>
        );
    }

}

PaymentSelector.propTypes = {
	/** Button label */
	choice: PropTypes.object.isRequired,
	/** Gets called when the user clicks on the item */
	onClick: PropTypes.func,
	/** boolean */
	selected: PropTypes.bool
}

PaymentSelector.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a PaymentSelector Component!', event.target);
	},
	/* eslint-enable no-console */
	selected: false
	
}


export default PaymentSelector;





// WEBPACK FOOTER //
// ./src/components/molecules/PaymentSelector/PaymentSelector.js